var map = {
	"./hiv_calc/butt.png": 1676,
	"./hiv_calc/condom.png": 6344,
	"./hiv_calc/female.png": 7283,
	"./hiv_calc/hand.png": 729,
	"./hiv_calc/iplus.png": 3956,
	"./hiv_calc/male.png": 5276,
	"./hiv_calc/mouth.png": 9013,
	"./hiv_calc/penis.png": 2217,
	"./hiv_calc/prep.png": 5348,
	"./hiv_calc/sti.png": 6803,
	"./hiv_calc/uplus.png": 6661,
	"./hiv_calc/vagina.png": 3901,
	"./logo.png": 4139,
	"./logo_big.png": 6259,
	"./logo_medium.png": 822
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8999;